// extracted by mini-css-extract-plugin
export var list = "NavigationLinks-module--list--2ZnCA";
export var item = "NavigationLinks-module--item--3DW9S";
export var link = "NavigationLinks-module--link--3XKoa";